import { api } from '@/lib/api';

// Pure encoding helpers live in common (ADR 024 — shared with the Studio
// pipeline without a features↔modules bidi pair); re-exported here so chat
// consumers keep one attachment-utils entry point.
export { fileToBase64, compressImageForVision } from '@/common/utils/file-encoding';

/**
 * Upload files to the API as workspace assets.
 * Returns an array of {id, attributes: {storageUrl}} objects.
 */
export async function uploadFilesToAssets(
  files: File[],
  conversationId: string,
  token: string | null,
  workspaceId?: string,
): Promise<Array<{ id: string; attributes: { storageUrl?: string } }>> {
  // Find default drive module to link uploads to — all files go to drive
  let defaultModuleId: string | undefined;
  if (token && workspaceId) {
    try {
      const modules = await api.workspaces.listWorkspaceModules(token, workspaceId);
      const driveModule = modules.find((m) => m.type === 'drive' && !m.archivedAt);
      if (driveModule) defaultModuleId = driveModule.id;
    } catch { /* proceed without */ }
  }

  return api.assets.uploadAssets({ files, conversationId, token, workspaceId, defaultModuleId });
}
